export function hasPermission(user, permission) {
  const permissions = user?.permissions;
  return permissions == null || permissions.includes(permission);
}
